import { CLAidedVA, CLEvaluation, CLOverRefraction } from '../../model/exam'
import { FundusExamMethodsType } from '../../model/fundusExamMethods'
import {
	BinocularAssessmentData,
	OcularHealthData,
	PhoriaHorizontalAssessmentData,
	PhoriaVerticalAssessmentData,
} from '../../model/manual'

export enum ContactLenseConditionSection {
	OverRefraction = 'overRefraction',
	Evaluation = 'evaluation',
	CLAidedVA = 'clAidedVa',
}

export type ContactLensesConditionValues = {
	overRefraction?: CLOverRefraction
	evaluation?: CLEvaluation
	clAidedVa?: CLAidedVA
}

export enum CheckboxFormKey {
	reason = 'reason',
}

export type ConditionsFormValues =
	| BinocularAssessmentData[
			| 'npa'
			| 'aniseikonia'
			| 'npc'
			| 'nraPra'
			| 'fusion'
			| 'coverTestDistance'
			| 'coverTestNear']
	| OcularHealthData['fundusExamMethods']
	| PhoriaHorizontalAssessmentData
	| PhoriaVerticalAssessmentData
	| PhoriaVerticalAssessmentData
	| PhoriaHorizontalAssessmentData

export type ConditionsValues =
	| BinocularAssessmentData['npa' | 'coverTestDistance' | 'coverTestNear']
	| Omit<BinocularAssessmentData['nraPra'], 'note'>
	| Omit<BinocularAssessmentData['npc'], 'note'>
	| Omit<BinocularAssessmentData['fusion'], 'note'>
	| Omit<BinocularAssessmentData['aniseikonia'], 'note'>
	| FundusExamMethodsType
	| PhoriaHorizontalAssessmentData
	| PhoriaVerticalAssessmentData
	| PhoriaVerticalAssessmentData
	| PhoriaHorizontalAssessmentData

export type EyeValues = Record<string, string | number | null | undefined>

export type GoldmannTonometryEyeT = {
	OD?: EyeValues
	OS?: EyeValues
}

export type GoldmannTonometryT = {
	goldmanTonometry?: GoldmannTonometryEyeT[]
}
